var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.039,
    height: 50.561,
    viewBox: "0 0 86.039 50.561",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "video-camera-svgrepo-com_1_",
    "data-name": "video-camera-svgrepo-com (1)",
    transform: "translate(12 -50.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-12 50.205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M81.741,81.514l-19.518,9.35V81.335a3,3,0,0,0-3-3c-31.583-.149-24.292-.192-56.221,0a3,3,0,0,0-3,3v44.43a3,3,0,0,0,3,3h56.22a3,3,0,0,0,3-3v-9.529l19.518,9.35a3,3,0,0,0,4.3-2.707V84.221A3,3,0,0,0,81.741,81.514ZM56.22,122.764H6V84.336H56.22C56.22,86.621,56.22,120.836,56.22,122.764Zm23.816-4.65L62.223,109.58V97.52l17.813-8.533Z",
    transform: "translate(0 -78.205)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.a65160e9ad711eb18637f500dab032cd.svg";
export { ForwardRef as ReactComponent };